<template>
  <div class="box">
    <!-- Mostrar contenido -->
    <PostContainer
      class="post-container"
      v-if="postData.available"
      :element="postContent"
      :model="model"
      :index="index"
    />
    <!-- Mostrar BLOQUEADO-->
    <PostBlockedContainer
      v-else-if="showBlocked"
      :data="postData"
      :content="postContent"
      :model="model"
    />
    <!-- Mostrar ELSE -->
    <div v-else>
      {{ $t("video_watch.not_available") }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { Post } from "~/types/Post";
import { Model } from "~/types/Model";
import { _NuxtApp } from "~/types/NuxtApp";

const { $i18n: { t: $t } } = <_NuxtApp>useNuxtApp();
const $emit = defineEmits(["changeMode", "enableModal"]);

interface _Props {
  postData: Post;
  postContent: any;
  model: Model;
  VideoElementHandler: any;
  index?: number;
}

const { 
  postData, 
  postContent, 
  model, 
  VideoElementHandler, 
  viewMode,
  index,
} = withDefaults(defineProps<_Props>(), {
  postContent: {},
  VideoElementHandler: {},
  viewMode: "vertical",
  index: 0,
});

const showBlocked = computed(() =>
  ["normal", "premium", "free", "tokens"].includes(postData.front_container)
);

const getVideoElementHandler = () => {
  return VideoElementHandler;
};

defineExpose({
  getVideoElementHandler
});
</script>

<style lang="scss" scoped>
.post-container {
  max-width: 100%;
  max-height: 90vh;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
}

.box {
  width: 100%;
}
</style>
